<template>
    <div class="home-container">
        <section class="hero-section">
            <div class="hero-overlay"></div>
            <v-container class="hero-container fill-height">
                <v-row align="center" justify="center">
                    <v-col cols="12" md="10" class="text-center hero-content">
                        <h1 class="display-3 font-weight-bold mb-6 hero-title">Roster Pal 2026</h1>
                        <p class="text-h5 font-weight-light mb-10 hero-subtitle">Your Ultimate Scheduling Assistant</p>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <!-- Primary Features Section -->
        <section class="features" style="padding-top: 10px; padding-bottom: 10px;">
            <v-container>
                <div class="text-center mb-16 px-4" style="padding-top: 10px; padding-bottom: 20px;">
                    <h2 class="text-h3 font-weight-bold mb-3 primary--text">Core Features</h2>
                    <div class="header-line primary mx-auto mb-4"></div>
                    <p class="text-h6 grey--text text--darken-1 font-weight-light">Essential tools designed for your daily workflow</p>
                </div>
                <v-row justify="center" class="gap-y-6">
                    <!-- Personal Roster Card -->
                    <v-col cols="12" sm="6" md="5" class="d-flex pa-4">
                        <v-card hover class="feature-card pa-8 text-center d-flex flex-column align-center w-100 h-100" @click="$router.push('/Personal')">
                            <v-avatar color="blue lighten-4" size="50" class="mb-8 elevation-3 icon-circle">
                                <v-icon size="30" color="blue darken-4">mdi-calendar-account</v-icon>
                            </v-avatar>
                            <v-card-title class="text-h5 font-weight-bold justify-center text-center mb-4">
                                Personal Roster
                            </v-card-title>
                            <v-card-text class="text-body-1 grey--text text--darken-2">
                                View your personalized schedule and manage your shifts with ease and precision.
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <!-- Team Roster Card -->
                    <v-col cols="12" sm="6" md="5" class="d-flex pa-4">
                        <v-card hover class="feature-card pa-8 text-center d-flex flex-column align-center w-100 h-100" @click="$router.push('/Team')">
                            <v-avatar color="deep-purple lighten-4" size="50" class="mb-8 elevation-3 icon-circle">
                                <v-icon size="30" color="deep-purple darken-4">mdi-account-group</v-icon>
                            </v-avatar>
                            <v-card-title class="text-h5 font-weight-bold justify-center text-center mb-4">
                                Team Roster
                            </v-card-title>
                            <v-card-text class="text-body-1 grey--text text--darken-2">
                                See who is on duty today and coordinate seamlessly with your entire team.
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <!-- Other Tools Section -->
        <section class="other-tools py-16 grey lighten-5">
            <v-container>
                <div class="text-center mb-16 px-4"  style="padding-top: 10px; padding-bottom: 20px;">
                    <h2 class="text-h3 font-weight-bold mb-3">Productivity Tools</h2>
                    <div class="header-line amber darken-3 mx-auto mb-4"></div>
                    <p class="text-h6 grey--text text--darken-1 font-weight-light">Extra utilities to supercharge your efficiency</p>
                </div>
                <v-row justify="center">
                    <!-- Sticky Notes Card -->
                    <v-col cols="12" sm="6" md="4" class="d-flex pa-4">
                        <v-card hover class="feature-card pa-8 text-center d-flex flex-column align-center w-100 h-100" @click="navigateToNotes">
                            <v-avatar color="orange lighten-4" size="50" class="mb-6 elevation-3 icon-circle">
                                <v-icon size="30" color="orange darken-4">mdi-note-multiple</v-icon>
                            </v-avatar>
                            <v-card-title class="text-h6 font-weight-bold justify-center text-center mb-3">
                                Note Pal
                            </v-card-title>
                            <v-card-text class="text-body-2 grey--text text--darken-2">
                                Paste the best, forget the rest! Quick access to all your important notes.
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <!-- toDo Card -->
                    <v-col cols="12" sm="6" md="4" class="d-flex pa-4">
                        <v-card hover class="feature-card pa-8 text-center d-flex flex-column align-center w-100 h-100" @click="navigateToToDo">
                            <v-avatar color="green lighten-4" size="50" class="mb-6 elevation-3 icon-circle">
                                <v-icon size="30" color="green darken-4">mdi-clipboard-check</v-icon>
                            </v-avatar>
                            <v-card-title class="text-h6 font-weight-bold justify-center text-center mb-3">
                                To Do Pal
                            </v-card-title>
                            <v-card-text class="text-body-2 grey--text text--darken-2">
                                Your personal productivity companion for tracking all your daily tasks.
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <!-- casePal Card -->
                    <v-col cols="12" sm="6" md="4" class="d-flex pa-4">
                        <v-card hover class="feature-card pa-8 text-center d-flex flex-column align-center w-100 h-100" @click="navigateToCasePal">
                            <v-avatar color="cyan lighten-4" size="50" class="mb-6 elevation-3 icon-circle">
                                <v-icon size="30" color="cyan darken-4">mdi-briefcase-search</v-icon>
                            </v-avatar>
                            <v-card-title class="text-h6 font-weight-bold justify-center text-center mb-3">
                                Case Pal
                            </v-card-title>
                            <v-card-text class="text-body-2 grey--text text--darken-2">
                                Efficiently track, manage, and monitor your queued cases in real-time.
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>
    </div>
</template>

<script>
export default {
    methods: {
        navigateToNotes() {
            window.location.href = "https://notepal.induwara.me/";
        },
        navigateToCasePal() {
            window.location.href = "https://chromewebstore.google.com/detail/case-pal-%F0%9F%8D%84/abnilakidigkoalmoihkaalhkjkgldbm?hl=en";
        },
        navigateToToDo() {
            window.location.href = "https://todo.induwara.me/";
        }
    }
};
</script>

<style scoped>
.home-container {
    margin-top: -80px; /* Pull content up to cover potential whitespace from parent padding */
}

.hero-section {
    position: relative;
    height: 35vh;
    min-height: 300px;
    background: url('@/assets/Roster_Pal.png') no-repeat center center/cover;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}

.hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(40, 10, 70, 0.8) 0%, rgba(70, 30, 120, 0.6) 100%);
    z-index: 1;
}

.hero-container {
    position: relative;
    z-index: 2;
    padding-top: 80px; /* Compensation for the header */
}

.hero-title {
    font-size: clamp(3.5rem, 5vw, 6rem) !important;
    text-shadow: 0 4px 12px rgba(0,0,0,0.5);
    letter-spacing: -2px !important;
    line-height: 1.1;
}

.hero-subtitle {
    text-shadow: 0 2px 8px rgba(0,0,0,0.4);
    opacity: 0.95;
}

.header-line {
    width: 80px;
    height: 4px;
    border-radius: 2px;
}

.features {
    background-color: #ffffff;
}

.feature-card {
    border-radius: 24px !important;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    background: white;
    border: 1px solid rgba(0,0,0,0.06) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
    overflow: hidden;
}

.feature-card .v-card__title {
    word-break: break-word;
    line-height: 1.3;
}

.feature-card .v-card__text {
    line-height: 1.6;
}

.feature-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 20px 40px -4px rgba(106, 51, 153, 0.45) !important;
    border-color: rgba(106, 51, 153, 0.7) !important;
}

.icon-circle {
    border: 3px solid white !important;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
    background: white;
}

.feature-card .v-avatar {
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.feature-card:hover .v-avatar {
    transform: scale(1.15) rotate(-15deg);
    box-shadow: 0 8px 25px rgba(0,0,0,0.45) !important;
}

@media (max-width: 600px) {
    .home-container {
        margin-top: -64px;
    }
    .hero-container {
        padding-top: 64px;
    }
    .hero-title {
        font-size: 2.5rem !important;
    }
}
</style>